/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import cookies from 'browser-cookies'

export const appcuesIdentify = () => {
  window.analytics.ready(() => {
    const appcuesId =
      cookies.get('ajs_user_id') !== null
        ? cookies.get('ajs_user_id')
        : cookies.get('ajs_anonymous_id') !== null
        ? cookies.get('ajs_anonymous_id')
        : null

    appcuesId === null ? window.Appcues?.anonymous() : window.Appcues?.identify(appcuesId)
  })
}
